module.exports = __webpack_public_path__ + "img/bx-class-timetable.287d0d11.svg";